/* eslint-disable eqeqeq */
import { getDisplayName } from '../../utils/members';

export function findBlockedEntity(blockedEntities, participant) {
    return blockedEntities?.length > 0 && blockedEntities.find((blocked) => {
        return parseInt(blocked.entityId) === parseInt(participant.entityId) && blocked.entityType === participant.entityType;
    });
}

export function getConversationSubtitle(conv, userId, blockedEntities) {
    if (conv.participants?.length === 2) {
        const other = conv.participants.find(person => person.entityId !== userId);
        if (findBlockedEntity(blockedEntities, other)) {
            return 'Currently Blocked';
        }
        return '';
    }

    if (conv.participants?.length > 2) {
        return `${conv.participants.length} people in this conversation`;
    }

    return '';
}

export function getOtherUserForUnblock(selectedConv, messaging, userId) {
    if (selectedConv?.participants?.length > 0) {
        return selectedConv.participants.find(user => user.entityId != userId);
    }

    if (messaging?.newConversation && messaging?.recepients?.length > 0) {
        const recipient = messaging.recepients[0];
        return { entityId: recipient.memberId, entityType: 'member', displayName: getDisplayName(recipient) };
    }

    return null;
}

export function getSelectedConversationData(messaging, userId) {
    const empty = { selectedConv: null, peoplesDict: {}, title: null, subtitle: null };

    if (!messaging?.convs?.length) {
        return empty;
    }

    if (messaging?.newConversation) {
        return { ...empty, title: 'New Message' };
    }

    const selectedConv = messaging?.selectedConv
        ? messaging.convs.find(conv => conv.id == messaging.selectedConv)
        : messaging.convs[0];

    if (!selectedConv) {
        return empty;
    }

    const peoplesDict = {};
    if (selectedConv.participants) {
        selectedConv.participants.forEach(person => {
            peoplesDict[person.id] = person;
        });
    }

    return {
        selectedConv,
        peoplesDict,
        title: selectedConv.title,
        subtitle: getConversationSubtitle(selectedConv, userId, messaging.blockedEntities),
    };
}
